// Copyright 2025, University of Maryland, All Rights Reserved
//
// Subsystem node auto-discovery using Vite's import.meta.glob.
//
// Automatically discovers and imports all register.ts files
// in the subsystems directory tree.

const registerModules = import.meta.glob('./**/register.ts', { eager: true })

export const DISCOVERED_SUBSYSTEM_NODES = Object.keys(registerModules).map((path) =>
  path.replace(/^\.\//, '').replace(/\/register\.ts$/, '')
)

if (import.meta.env.DEV) {
  console.debug(`[subsystems] Discovered ${DISCOVERED_SUBSYSTEM_NODES.length} nodes:`, DISCOVERED_SUBSYSTEM_NODES)
}
